// extracted by mini-css-extract-plugin
export default {"blog":"styles_blog__o7I+w","blog__link":"styles_blog__link__Qh3DX","item":"styles_item__3P9Lf","item__in":"styles_item__in__plDuy"};